var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',[_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{staticClass:"overlay-spinner",attrs:{"indeterminate":"","size":"64","color":"primary"}})],1),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }